import store, {
    handleAccount,
    handleCMS,
    handleExhibition,
    handleGlobal,
    handleCompete
} from "@/(front-desk)/store/index"
import { reportError } from "@/(front-desk)/utils/functions"
import lscache from "lscache"
import axios from "axios"

const dispatch = store.dispatch
export const getAccountInfo = (dispatch) => {
    axios.get('/api/v1/accounts/me', {
        headers: {
            Authorization: `Bearer ${lscache.get('access')}`
        }
    })
    .then((res) => {
        console.log('account info: ', res.data.body)
        dispatch(handleAccount.actions.setData(res.data.body))
    })
    .catch((err) => {
        // console.log(err.config?.url, err)
        dispatch(handleAccount.actions.setData(false))
        if (err.config?.url !== '/api/v1/accounts/token/refresh') {
            reportError(err, true)
        }
    })
}
export const getExhibitionOverview = (dispatch, year) => {
    axios.get(`/api/v1/exhibition/${year}/overview`, {
        headers: {
            Authorization: `Bearer ${lscache.get('access')}`
        }
    })
    .then((res) => {
        if (res.data.body) {
            // console.log('exhibition overview: ', res.data.body)
            dispatch(handleExhibition.actions.setOverview(res.data.body))
            dispatch(handleExhibition.actions.setGroupProjects(res.data.body.group?.project_info || false))
            dispatch(handleExhibition.actions.setGroupProject(res.data.body.group?.project_info?.[0] || false))
            dispatch(handleExhibition.actions.setIndividualProjects(res.data.body.individual?.individual_projects || false))
            if (res.data.body.individual?.available_competition_projects?.length > 0) {
                getExhibitionIndividualAvailable()
            }
            else {
                dispatch(handleExhibition.actions.setIndividualAvailableProjects(res.data.body.individual?.available_competition_projects || false))
            }
        }
        else {
            dispatch(handleExhibition.actions.setOverview(false))
        }
    })
    .catch((err) => {
        // console.log(err.config?.url, err)
        dispatch(handleExhibition.actions.setOverview(false))
        reportError(err, false)
    })
}
export const getExhibitionIndividualAvailable = () => {
    const year = store.getState().global.currentExhibitYear
    axios.get(`/api/v1/exhibition/${year}/individual/projects/available`, {
        headers: {
            Authorization: `Bearer ${lscache.get('access')}`
        }
    })
    .then((res) => {
        // console.log('exhibition individual available: ', res.data.body)
        dispatch(handleExhibition.actions.setIndividualAvailableProjects(res.data.body || false))
    })
    .catch((err) => {
        // console.log(err.config?.url, err)
        dispatch(handleExhibition.actions.setIndividualAvailableProjects(false))
        reportError(err, true)
    })
}
export const getSchoolList = (year) => {
    axios.get(`/api/v1/activity/years/${year}/schools`)
    .then((res) => {
        // console.log('school list', res)
        if (res.data.body?.length > 0) {
            let list = []
            for (const school of res.data.body) {
                list.push({
                    id: school.id,
                    label: school.name,
                    value: school.name,
                    code: school.moe_code
                })
            }
            dispatch(handleGlobal.actions.setSchoolList(list))
        }
        else {
            dispatch(handleGlobal.actions.setSchoolList(false))
        }
    })
    .catch((err) => {
        // console.log(err.config?.url, err)
        dispatch(handleGlobal.actions.setSchoolList(false))
        reportError(err, true)
    })
}
export const getGroupStages = (dispatch, year) => {
    axios.get(`/api/v1/activity/years/${year}/exhibition-group/stages`)
    .then((res) => {
        // console.log('group stages:', res.data.body)
        dispatch(handleExhibition.actions.setGroupStages(res.data.body))
    })
    .catch((err) => {
        // console.log(err.config?.url, err)
        dispatch(handleExhibition.actions.setGroupStages(false))
        reportError(err, true)
    })
}
export const getIndividualStage = (dispatch, year) => {
    axios.get(`/api/v1/activity/years/${year}/exhibition-individual/stages`)
    .then((res) => {
        // console.log('individual stages:', res.data.body)
        dispatch(handleExhibition.actions.setIndividualStages(res.data.body))
    })
    .catch((err) => {
        // console.log(err.config?.url, err)
        dispatch(handleExhibition.actions.setIndividualStages(false))
        reportError(err, true)
    })
}
export const getFeeConfig = (dispatch, year) => {
    axios.get(`/api/v1/exhibition/${year}/fee-config`, {
        headers: {
            Authorization: `Bearer ${lscache.get('access')}`
        }
    })
    .then((res) => {
        // console.log(res.config.url, res.data.body)
        if (res.data?.body) {
            dispatch(handleExhibition.actions.setFeeConfig(res.data.body))
        }
        else {
            dispatch(handleExhibition.actions.setFeeConfig(false))
        }
    })
    .catch((err) => {
        // console.log(err.config?.url, err)
        dispatch(handleExhibition.actions.setFeeConfig(false))
        reportError(err, true)
    })
}
export const getRegistries = (dispatch) => {
    axios.get('/api/v1/cms/registries')
    .then((res) => {
        // console.log('registries success: ', res.data.body)
        dispatch(handleCMS.actions.setRegistries(res.data.body))
    })
    .catch((err) => {
        // console.log(err.config?.url, err)
        dispatch(handleCMS.actions.setRegistries(false))
        reportError(err, true)
    })
}


// compete function
export const getCompeteStages = (dispatch, year) => {
    axios.get(`/api/v1/activity/years/${year}/competition/stages`, {
        headers: {
            Authorization: `Bearer ${lscache.get('access')}`
        }
    })
    .then((res) => {
        console.log('compete stages: ', res.data.body)
        dispatch(handleCompete.actions.setStages(res.data.body))
    })
    .catch((err) => {
        // console.log(err.config?.url, err)
        dispatch(handleCompete.actions.setStages(false))
        reportError(err, true)
    })
}
export const getCompeteCategories = () => {
    axios.get(`/api/v1/competition/${store.getState().global.currentCompeteYear}/categories`, {
        headers: {
            Authorization: `Bearer ${lscache.get('access')}`
        }
    })
    .then((res) => {
        console.log('compete categories: ', res.data.body)
        dispatch(handleCompete.actions.setCategories(res.data.body))
    })
    .catch((err) => {
        // console.log(err.config?.url, err)
        dispatch(handleCompete.actions.setCategories(false))
        reportError(err, true)
    })
}
export const storeCompeteProject = (selected, page, page_size, search_year) => {
    const year = store.getState().global.currentCompeteYear
    axios.get(`/api/v1/competition/${year}/projects${selected ? `?selected=${selected}` : ""}${page ? `&page=${page}` : ""}${page_size ? `&page_size=${page_size}` : ""}${search_year ? `&search_year=${search_year}` : ""}`, {
        headers: {
            Authorization: `Bearer ${lscache.get('access')}`
        }
    })
    .then((res) => {
        console.log(selected, res.data.body)
        switch (selected) {
            case "submitted":
                dispatch(handleCompete.actions.setSubmitted(res.data.body))
                break;
            case "draft":
                dispatch(handleCompete.actions.setDraft(res.data.body))
                break;
            case "history":
                dispatch(handleCompete.actions.setHistory(res.data.body))
                break;
            default:
                dispatch(handleCompete.actions.setData(res.data.body))
                break;
        }
    })
    .catch((err) => {
        // console.log(err.config?.url, err)
        reportError(err, true)
    })
}
// export const getCompeteProject = (year, selected, page, page_size, search_year) => axios.get(`/api/v1/competition/${year}/projects${selected ? `?selected=${selected}` : ""}${page ? `&page=${page}` : ""}${page_size ? `&page_size=${page_size}` : ""}${search_year ? `&search_year=${search_year}` : ""}`, {
//     headers: {
//         Authorization: `Bearer ${lscache.get('access')}`
//     }
// })
export const getCompeteProjectDetail = (year, id) => axios.get(`/api/v1/competition/${year}/projects/${id}`, {
    headers: {
        Authorization: `Bearer ${lscache.get('access')}`
    }
})
export const deleteCompeteProject = (id) => axios.delete(`/api/v1/competition/${store.getState().global.currentCompeteYear}/projects/${id}`, {
    headers: {
        Authorization: `Bearer ${lscache.get('access')}`
    }
})
export const createNewProject = (year, formData) => axios.post(`/api/v1/competition/${year}/projects`, formData, {
    headers: {
        Authorization: `Bearer ${lscache.get('access')}`
    }
})
export const updateProject = (year, id, formData) => axios.patch(`/api/v1/competition/${year}/projects/${id}`, formData, {
    headers: {
        Authorization: `Bearer ${lscache.get('access')}`
    }
})
export const createFilePack = (data) => axios.post("/api/v1/docs/packs", data, {
    headers: {
        Authorization: `Bearer ${lscache.get('access')}`
    }
})
export const uploadFile = (pack_id, formData) => axios.post(`/api/v1/docs/packs/${pack_id}/files`, formData, {
    headers: {
        Authorization: `Bearer ${lscache.get('access')}`
    }
})